import { Component, OnDestroy, OnInit } from '@angular/core';
import { PaymentService } from '../../services/payment.service';
import { interval, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentStateEnum } from '../../models/payment-state.enum';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pending',
  templateUrl: './pending.component.html',
  styleUrls: ['./pending.component.scss']
})
export class PendingComponent implements OnInit, OnDestroy {
  private pendingInterval: Subscription;

  constructor(private paymentService: PaymentService, private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.pendingInterval = interval(environment.poolingInterval)
      .pipe(switchMap(() => this.paymentService.getPayment()))
      .subscribe(data => {
        if (data.paymentState !== PaymentStateEnum.STARTED) {
          this.router.navigate(['../result'], { relativeTo: this.activatedRoute });
        }
      });
  }

  ngOnDestroy(): void {
    this.pendingInterval.unsubscribe();
  }

  startPaymentAgain() {
    this.paymentService.startPaymentAgain().subscribe(() => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }
}
